<template>
<div id="wrap" class="login">
  <div id="header" class="load">

     <div class="headerTop clearfix">
       <div class="headerTop_left">
        <p></p>
      </div>
      </div>
     <div class="headerBot">
       <h1>
         <router-link to="/" class="logo"><img src="/static/images/common/logo_damda.png" alt="담다" class="logo_white"><img src="/static/images/common/DAMDA_logo.png" alt="" class="logo_color"></router-link>
       </h1>
     </div>
  </div>

  <!-- 비밀번호 재발급 -->
  <form @submit.prevent="onSubmit">
  <ValidationObserver v-slot="{ invalid }" ref="form">
  <div id="container_app" class="login">
    <div class="mv_for_login winH">
      <div class="LoginTit aniBox2  gogo">
        <center>회원가입 시 등록한 정보를 기반으로 모든 항목이 일치하면 이메일로 임시 비밀번호를 발송해 드립니다.</center>
        <strong>비밀번호 재발급</strong>
      </div>

      <div class="pwBox aniBox">
        <dl>
          <dt>아이디 (이메일)</dt>
          <dd class="inputBox">
            <ValidationProvider name="userId" rules="required|email" v-slot="{ errors, invalid }">
            <input type="text" name="userId" class="input_ty2" autocomplete="off" placeholder="아이디는 이메일 형식입니다." v-model="userInfo.userId">
            <p class="is-invalid">{{ errors[0] }}</p>
            </ValidationProvider>
          </dd>
        </dl>
        <dl>
          <dt>성명</dt>
          <dd class="inputBox">
            <ValidationProvider name="userName" rules="required" v-slot="{ errors, invalid }">
            <input type="text" name="userName" class="input_ty2" autocomplete="off" placeholder="이름을 입력하세요." v-model="userInfo.userName">
            <span class="is-invalid">{{ errors[0] }}</span>
            </ValidationProvider>
          </dd>
        </dl>
        <dl>
          <dt>휴대폰 번호</dt>
          <dd class="inputBox">
            <ValidationProvider name="userPhone" rules="required" v-slot="{ errors, invalid }">
            <input type="text" name="userPhone" class="input_ty2" placeholder="휴대폰 번호를 '-'없이 숫자만 입력하세요."  v-model="userInfo.userPhone">
            <span class="is-invalid">{{ errors[0] }}</span>
            </ValidationProvider>
          </dd>
        </dl>
        <div class="btn_area taC aniBox type_top gogo">
          <a href="javascript:" class="btn_blue" @click="onSubmit()">비밀번호 재발급</a>
        </div>
      </div>
    </div>
  </div>
  <!-- 비밀번호 재발급 -->
  </ValidationObserver>
  </form>
  <loading :active.sync="isLoading"
       :can-cancel="false"
       :is-full-page="fullPage"></loading>
</div>

</template>

<script>
import axios from 'axios'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, between, confirmed, min, max, regex } from 'vee-validate/dist/rules'
import ko from 'vee-validate/dist/locale/ko.json'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

localize(ko)
extend('required', {
  ...required,
  message: '필수 입력 항목입니다.'
})
extend('email', {
  ...email,
  message: '이메일 형식이 필요합니다.'
})
extend('between', {
  ...between,
  message: '비밀번호 길이를 확인해주세요'
})
extend('confirmed', {
  ...confirmed,
  message: '비밀번호 확인값과 일치하지 않습니다.'
})
extend('min', {
  ...min,
  message: '값이 {length}자리 이상이어야 합니다.'
})
extend('max', {
  ...max,
  message: '값이 {length}자리 이하이어야 합니다.'
})
extend('regex', {
  ...regex,
  message: '비밀번호는 영문과 숫자, 특수문자가 포함되어야 합니다.'
})

export default {
  name: 'MemberForgotPassword',
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading
  },
  data () {
    return {
      userInfo: {
        userId: '',
        userName: '',
        userPhone: ''
      },
      isLoading: false,
      fullPage: true
    }
  },
  mounted () {
    this.$parent.showHeader = false
    this.$parent.showFooter = false
  },
  destroyed () {
    this.$parent.showHeader = true
    this.$parent.showFooter = true
  },
  methods: {
    onSubmit: function () {
      var _this = this
      this.$refs.form.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          axios({
            method: 'POST',
            url: '/web/api/member/lostPasswd',
            data: this.userInfo,
            withCredentials: true
          }).then((response) => {
            alert('비밀번호 재발급 메일을 발송하였습니다.')
            _this.isLoading = false
            // location.href = '/'
            _this.$router.push('/')
          }).catch((ex) => {
            alert('비밀번호 재발급에 실패하였습니다. 입력 정보를 확인해 주세요.')
            _this.isLoading = false
            console.log('비밀번호 재발급 오류 : ', ex)
          })
        }
      })
    },
    gohome: function () {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.is-invalid { color:red;  line-height: 3; padding-left: 20px;}
.is-invalidF { border-color:red; }
</style>



// WEBPACK FOOTER //
// src/components/MemberForgotPassword.vue